import { useContext } from "react";

import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useInvalidateInvitedUserListQuery } from "@/queries/query-user-invited";
import { ProjectContext } from "@/stores/project-provider";

export function useInviteUserToProject() {
  const { id: projectId } = useContext(ProjectContext);
  const invalidateInvitedUsersQuery = useInvalidateInvitedUserListQuery();

  return useMutationWithErrorHandler(async (email: string) => {
    const createResponse = await getRanaApiV1().InvitationsApi.invitationCreate({
      invitationCreate: {
        email,
        tenantRole: "guest",
        project: projectId,
        projectRole: "collaborator",
      },
    });

    const sendResponse = getRanaApiV1().InvitationsApi.invitationSendEmail({
      invitationId: createResponse.id,
    });

    invalidateInvitedUsersQuery();

    return sendResponse;
  });
}
